const AttachFileOrder = ({
  selectedFiles,
  currentColor,
  loading,
  handleFileSelect,
  removeFile,
  downloadFile,
  viewOnly = false,
}) => (
  <div>
    {!viewOnly && (
      <>
        <input
          type="file"
          id="pdf-upload"
          accept="application/pdf"
          multiple
          onChange={handleFileSelect}
          className="hidden"
        />
        <label
          className={`text-xs pt-2 pb-2 pl-3 pr-3 m-2 cursor-pointer rounded-md text-white`}
          htmlFor={!loading && selectedFiles.length < 4 ? "pdf-upload" : ""}
          style={{ backgroundColor: currentColor }}
        >
          {selectedFiles.length >= 4
            ? `Maximum 4 Files Attached`
            : "+ Add Attachment"}
        </label>
      </>
    )}
    {selectedFiles.length > 0 && (
      <div className="mb-6">
        <h5 className="font-medium mb-2">
          Attached Files ({selectedFiles.length})
        </h5>
        <div className="space-y-2 max-h-48 overflow-auto">
          {selectedFiles.map((file, index) => (
            <div
              key={index}
              className="flex items-center justify-between bg-white p-3 pb-2 rounded-lg"
            >
              <div className="flex items-center gap-3 w-100 max-w-80 overflow-auto">
                <span className="text-red-600 pb-2">📄</span>
                <div>
                  <p className="font-medium text-sm mb-2">{file.name}</p>
                  {/* <p className="text-xs text-gray-500 mb-2">
                    {`${file.size ? (file.size / 1024 / 1024).toFixed(2) + " MB" : "-"}`}
                  </p> */}
                </div>
              </div>
              {file.id && (
                <button
                  onClick={() => downloadFile(file.id)}
                  className="text-gray-500 hover:text-gray-900 text-xl leading-none pb-2"
                >
                  ↓
                </button>
              )}
              {!viewOnly && (
                <button
                  onClick={() => removeFile(index)}
                  className="text-red-500 hover:text-red-700 text-xl leading-none pb-2"
                >
                  ×
                </button>
              )}
            </div>
          ))}
        </div>
      </div>
    )}
  </div>
);

export default AttachFileOrder;

// const fileToByteArray = async (file) => {
//   return new Promise((resolve, reject) => {
//     const reader = new FileReader();

//     reader.readAsArrayBuffer(file); // Important: Use ArrayBuffer
//     reader.onload = (event) => {
//       if (event.target?.result instanceof ArrayBuffer) {
//         const byteArray = new Uint8Array(event.target.result);
//         resolve(byteArray);
//       } else {
//         reject(new Error("Failed to convert file to byte array"));
//       }
//     };

//     reader.onerror = () => reject(new Error("File reading error"));
//   });
// };

// const fileToBase64 = async (file) => {
//   return new Promise((resolve, reject) => {
//     const reader = new FileReader();

//     reader.onload = () => {
//       // reader.result will be: "data:application/pdf;base64,JVBERi0xLjQKJcOkw7zDtsOf..."
//       const base64String = reader.result;

//       // Option 1: Send full Data URL (recommended if backend expects it)
//       resolve(base64String);

//       // Option 2: Send only Base64 part (without "data:application/pdf;base64,")
//       // const pureBase64 = base64String.split(',')[1];
//       // resolve(pureBase64);
//     };

//     reader.onerror = () => reject(new Error("Failed to read file"));
//     reader.readAsDataURL(file); // Use DataURL for Base64
//   });
// };
